import Vue from 'vue';
import ElementUI from 'element-ui';
// import { Select, Option, Input, Pagination, Button,Tabs } from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './style/base.scss';
import * as filters from '@/filter/index.js';
import directives from '@/directive/index.js';
import message from '@/utils/message.js';
import interceptor from '@/interceptor/index.js';
import datePicker from '@/components/date-picker/index.vue';

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.component('DatePicker', datePicker);

// 过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 自定义指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});
// 消息提醒
Object.keys(message).forEach(key => {
  Vue.prototype['$' + key] = message[key];
});
interceptor.init();

Vue.prototype.toast = function(event){
  const modalDom = document.createElement('div');
  const duration =  event.duration ? event.duration * 1000 : 1500;
  modalDom.innerHTML = event.message;
  modalDom.className = 'toast';
  document.body.appendChild(modalDom);
  setTimeout(() => {
    document.body.removeChild(modalDom);
  }, duration);
};

Vue.use(ElementUI);
// Vue.use(Select);
// Vue.use(Option);
// Vue.use(Input);
// Vue.use(Pagination);
// Vue.use(Button);
// Vue.use(Tabs);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
